module.exports = __webpack_public_path__ + "img/ride the wire.31c1249f.jpg";